import React from "react";
import { buildColor } from "@tvg/design-system";
import styled, { keyframes } from "styled-components";
import { RunnerModifierEnum } from "../../types";

const pulseAnimation = keyframes`
  0% {
   opacity: 1
  }
  
  50% {
    opacity: 0.5
  }
  
  100% {
    opacity: 1
  }
`;

const SVG = styled.svg`
  animation: ${pulseAnimation} 1.25s infinite;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${buildColor("white", "900")};
`;

const DefaultLoading = () => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="80"
    viewBox="0 0 375 80"
    fill="none"
    preserveAspectRatio="none"
  >
    <g filter="url(#filter0_i_4313_332785)">
      <rect width="375" height="80" fill="white" />
      <path
        d="M12 0H44V64C44 66.2091 42.2091 68 40 68H16C13.7909 68 12 66.2091 12 64V0Z"
        fill="#E9EFF5"
      />
      <rect x="56" y="15" width="150" height="12" rx="1" fill="#E9EFF5" />
      <rect x="56" y="34" width="220" height="12" rx="1" fill="#E9EFF5" />
      <rect x="56" y="53" width="220" height="12" rx="1" fill="#E9EFF5" />
      <rect x="293" y="16" width="70" height="48" rx="2" fill="#E9EFF5" />
    </g>
    <defs>
      <filter
        id="filter0_i_4313_332785"
        x="0"
        y="0"
        width="375"
        height="80"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_4313_332785"
        />
      </filter>
    </defs>
  </SVG>
);

const AdvancedLoading = () => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="156"
    viewBox="0 0 375 156"
    fill="none"
    preserveAspectRatio="none"
  >
    <g filter="url(#filter0_i_1114_232996)">
      <rect width="375" height="156" fill="white" />
      <path
        d="M12 0H44V64C44 66.2091 42.2091 68 40 68H16C13.7909 68 12 66.2091 12 64V0Z"
        fill="#E9EFF5"
      />
      <rect x="56" y="15" width="150" height="12" rx="1" fill="#E9EFF5" />
      <rect x="56" y="34" width="220" height="12" rx="1" fill="#E9EFF5" />
      <rect x="56" y="53" width="220" height="12" rx="1" fill="#E9EFF5" />
      <rect x="293" y="16" width="70" height="48" rx="2" fill="#E9EFF5" />
      <rect x="12" y="84" width="351" height="12" rx="1" fill="#E9EFF5" />
      <rect x="12" y="100" width="264" height="12" rx="1" fill="#E9EFF5" />
      <rect x="12" y="129" width="264" height="12" rx="1" fill="#E9EFF5" />
    </g>
    <defs>
      <filter
        id="filter0_i_1114_232996"
        x="0"
        y="0"
        width="375"
        height="156"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1114_232996"
        />
      </filter>
    </defs>
  </SVG>
);

const PerformanceLoading = () => (
  <SVG
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="170"
    viewBox="0 0 375 170"
    fill="none"
    preserveAspectRatio="none"
  >
    <g filter="url(#filter0_i_1114_232997)">
      <rect width="375" height="170" fill="white" />
      <path
        d="M12 0H44V64C44 66.2091 42.2091 68 40 68H16C13.7909 68 12 66.2091 12 64V0Z"
        fill="#E9EFF5"
      />
      <rect x="56" y="15" width="150" height="12" rx="1" fill="#E9EFF5" />
      <rect x="56" y="34" width="220" height="12" rx="1" fill="#E9EFF5" />
      <rect x="56" y="53" width="220" height="12" rx="1" fill="#E9EFF5" />
      <rect x="293" y="16" width="70" height="48" rx="2" fill="#E9EFF5" />
      <rect x="12" y="83" width="90" height="12" rx="1" fill="#E9EFF5" />
      <rect x="12" y="103" width="90" height="12" rx="1" fill="#E9EFF5" />
      <rect x="12" y="123" width="90" height="12" rx="1" fill="#E9EFF5" />
      <rect x="12" y="143" width="90" height="12" rx="1" fill="#E9EFF5" />
      <rect x="160" y="83" width="75" height="12" rx="1" fill="#E9EFF5" />
      <rect x="160" y="103" width="75" height="12" rx="1" fill="#E9EFF5" />
      <rect x="160" y="123" width="75" height="12" rx="1" fill="#E9EFF5" />
      <rect x="293" y="83" width="70" height="12" rx="1" fill="#E9EFF5" />
      <rect x="293" y="103" width="70" height="12" rx="1" fill="#E9EFF5" />
      <rect x="293" y="123" width="70" height="12" rx="1" fill="#E9EFF5" />
    </g>
    <defs>
      <filter
        id="filter0_i_1114_232997"
        x="0"
        y="0"
        width="375"
        height="170"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="-1" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.839216 0 0 0 0 0.890196 0 0 0 0 0.941176 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_1114_232997"
        />
      </filter>
    </defs>
  </SVG>
);

interface RunnerMobileLoadingProps {
  variant: "default" | "advanced" | "performance";
  numberOfCards?: number;
}

const RunnerMobileLoading = ({
  variant = RunnerModifierEnum.DEFAULT,
  numberOfCards = 1
}: RunnerMobileLoadingProps) => {
  const loading = {
    [RunnerModifierEnum.DEFAULT]: DefaultLoading,
    [RunnerModifierEnum.ADVANCED]: AdvancedLoading,
    [RunnerModifierEnum.PERFORMANCE]: PerformanceLoading
  };

  const isValidVariant = ["default", "advanced", "performance"].includes(
    variant
  );

  const Component = isValidVariant ? loading[variant] : DefaultLoading;

  return (
    <Container>
      {Array.from(Array(numberOfCards).keys()).map((_, index) => (
        <Component key={index.toString()} />
      ))}
    </Container>
  );
};

export default RunnerMobileLoading;
